<template class="full-height">
  <div class="full-height traveler-data">
    <!-- 客訴備註 -->
    <el-dialog
      custom-class="traveler-complaint-remind"
      append-to-body
      :title="`客訴備註`"
      :visible.sync="dialogFormVisible"
      width="70%"
    >
      <el-form
        ref="complaintRemindForm"
        :model="complaintRemindForm"
        size="mini"
        @submit.native.prevent
      >
        <el-form-item prop="complaintRemind">
          <el-input
            type="textarea"
            :rows="10"
            v-model="complaintRemindForm.complaintRemind"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="saveData" size="mini" type="success">儲 存</el-button>

        <el-button @click="dialogFormVisible = false" size="mini" type="danger">關 閉</el-button>
      </span>
    </el-dialog>
    <el-form :inline="true" class="filter-form" @submit.native.prevent>
      <el-form-item label="查詢">
        <el-input
          v-model="listQuery.qry"
          placeholder="輸入旅客姓名"
          @keyup.enter.native="getList"
        />
      </el-form-item>

      <el-button
        type="primary"
        @click="getList"
        icon="el-icon-search"
        circle
        style="margin-top: 8px; margin-left: 5px"
        :disabled="listLoading"
      ></el-button>
      <!-- <el-button
        type="warning"
        @click="addData"
        circle
        icon="el-icon-plus"
        :disabled="listLoading"
      ></el-button> -->

      <el-button
        style="cursor: pointer"
        type="success"
        :loading="listLoading"
        circle
        icon="el-icon-refresh-left"
        @click="refresh()"
      ></el-button>
    </el-form>

    <div style="position: relative; height: 80%">
      <el-table
        ref="formDetailsTable"
        v-loading="listLoading"
        :data="list"
        size="mini"
        border
        fit
        style="width: 100%"
        height="100%"
        :row-class-name="tableRowStatus"
        @sort-change="sortChange"
      >
        <el-table-column align="center" label="數量" width="1" type="expand">
          <template slot-scope="scope">
            <el-table
              size="mini"
              :data="scope.row.travels"
              border
              style="width: 100%"
              height="200"
              :row-class-name="tableRowClassName"
            >
              <el-table-column align="center" label="" :min-width="50">
                <template slot-scope="scope">
                  <span style="font-size:14px;text-align:left;'">{{ scope.row.travelName }}</span>
                  <div>
                    <el-tag size="mini">
                      出發
                      <span style="color: red">{{ `${scope.row.beginDate}` }}</span>
                      - 回程
                      <span style="color: red">{{ `${scope.row.endDate}` }}</span>
                    </el-tag>
                  </div>
                </template>
              </el-table-column>
              <el-table-column align="center" label="" :min-width="50">
                <template slot-scope="scope">
                  <div
                    style="display: flex; align-items: center; justify-content: center; gap: 0 8px"
                  >
                    <p>滿意度</p>
                    <el-tag
                      style="font-size: 20px; font-weight: bold"
                      :type="getSatisfactionAnalysisStyle(scope.row.satisfactionPoint)"
                    >
                      {{ scope.row.satisfactionPoint }}
                    </el-tag>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </template>
        </el-table-column>

        <el-table-column align="center" label="項次" width="60">
          <template slot-scope="scope">
            <span>{{ scope.$index + 1 }}</span>
          </template>
        </el-table-column>

        <!-- <el-table-column align="center" label="姓名" width="160">
          <template slot-scope="{ row }">
            <span>{{ row.travelName }}</span>
          </template>
        </el-table-column> -->

        <el-table-column align="center" label="姓名" width="160">
          <template slot-scope="{ row }">
            <span>
              {{ row.travelName }}
              <span v-if="row.passportEnName && row.passportEnName.trim() !== ''">
                {{ ' ' + row.passportEnName }}
              </span>
            </span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="生日" width="100">
          <template slot-scope="{ row }">
            <span>{{ row.birthDay }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="手機號碼" width="100">
          <template slot-scope="scope">
            <span>{{ scope.row.mobile }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="E-MAIL" width="160">
          <template slot-scope="scope">
            <span>{{ scope.row.mail }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="身分證字號" width="160">
          <template slot-scope="scope">
            <span>{{ scope.row.idCard }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="護照號碼" width="160">
          <template slot-scope="scope">
            <span>{{ scope.row.passportNo }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="護照照片" width="160">
          <template slot-scope="scope">
            <el-image
              v-if="scope.row.passportUrl && !scope.row._imgError"
              style="width: 80px; height: auto"
              :src="scope.row.passportUrl"
              :preview-src-list="[scope.row.passportUrl]"
              fit="contain"
              @error="scope.row._imgError = true"
            />
          </template>
        </el-table-column>

        <el-table-column align="center" label="旅行社備註" width="160">
          <template slot-scope="scope">
            <span>{{ scope.row.agencyRemind }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="領隊備註" width="160">
          <template slot-scope="scope">
            <span>{{ scope.row.leaderRemind }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="出團數" width="120">
          <template slot-scope="scope">
            <el-tag
              @click="toggleExpand(scope.row)"
              type="success"
              style="font-size: 15px; font-weight: bold; cursor: pointer"
              >{{ scope.row.toursCount }}
            </el-tag>
          </template>
        </el-table-column>

        <el-table-column align="center" label="客訴" width="60">
          <template slot-scope="scope">
            <el-popconfirm
              title="確定要變更客訴狀態嗎？"
              @confirm="handleCheckComplaint(scope.row)"
              cancel-button-text="取消"
              confirm-button-text="確定"
            >
              <el-checkbox
                slot="reference"
                @click.native.prevent=""
                :value="scope.row.hasComplaint"
              >
              </el-checkbox>
            </el-popconfirm>
          </template>
        </el-table-column>

        <el-table-column align="center" label="客訴備註" width="120">
          <template slot-scope="scope">
            <el-button type="success" @click="editData(scope.row)" size="mini"> 編輯 </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <pagination
      v-show="total > 0"
      layout="prev, pager, next"
      :total="total"
      :page.sync="listQuery.page"
      :limit.sync="listQuery.limit"
      @pagination="getList"
    />
  </div>
</template>

<script>
import checkPermission from '@/utils/permission' // 权限判断函数
import Pagination from '@/components/Pagination' // Secondary package based on el-pagination
import { Message } from 'element-ui'
import { getTravelersManagement, setTravelersManagement } from '@/api/agency'
import TravelerData from '@/views/ita/components/travelerViewData.vue'

export default {
  name: 'TravelerTable',
  components: { Pagination, TravelerData },
  props: {
    // 外部傳入的物件
    agencyCode: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      selectedTraveler: {},
      authEdit: false,
      dialogFormVisible: false,
      listLoading: false,
      formLoading: false,
      listQuery: {
        qry: '',
        agencyCode: '',
        date: '',
        status: null,
        page: 1,
        limit: 20,
        sort: '-id',
      },
      total: 0,
      list: [],
      complaintRemindForm: {
        userID: null,
        hasComplaint: false,
        complaintRemind: '',
      },
    }
  },
  watch: {
    agencyCode: function (value) {
      if (value) {
        this.listQuery.agencyCode = value
        this.getList()
      }
    },
  },
  async created() {
    this.listQuery.agencyCode = this.agencyCode
    await this.getList()
  },
  methods: {
    checkPermission,
    async refresh() {
      this.defaultListQuerySetting()
      await this.getList()
    },
    sortChange(data) {
      const { prop, order } = data
      debugger
      this.sortByColumn(prop, order)
    },
    sortByColumn(sort, order) {
      if (order === 'ascending') {
        this.listQuery.sort = `+${sort}`
      } else if (order === 'descending') {
        this.listQuery.sort = `-${sort}`
      } else {
        const s = this.listQuery.sort[0]
        if (s === '+') {
          this.listQuery.sort = `-${sort}`
        } else if (s === '-') {
          this.listQuery.sort = `+${sort}`
        } else {
          this.listQuery.sort = `+${sort}`
        }
      }
      this.handleFilter()
    },
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    getSatisfactionAnalysisStyle(v) {
      let tryParseInt = parseInt(v)
      let style = ''
      //旅客
      switch (true) {
        case tryParseInt <= 2.9:
          style = 'danger'
          break
        case tryParseInt <= 3.9:
          style = 'warning'
          break
        default:
          style = 'success'
          break
      }

      return style
    },

    toggleExpand(row) {
      console.log(row)
      let $table = this.$refs.formDetailsTable
      $table.toggleRowExpansion(row)
    },

    handleCheckComplaint(row) {
      this.complaintRemindForm.userID = row.userID
      this.complaintRemindForm.hasComplaint = !this.complaintRemindForm.hasComplaint
      this.complaintRemindForm.complaintRemind = this.complaintRemindForm.complaintRemind
      this.saveData()
    },
    tableRowClassName({ row, rowIndex }) {
      return 'success-row'
    },
    tableRowStatus({ row, rowIndex }) {
      return row.hasComplaint ? 'alert-row' : ''
    },
    defaultListQuerySetting() {
      this.listQuery = {
        qry: '',
        agencyCode: this.agencyCode,
        date: '',
        status: null,
        page: 1,
        limit: 20,
        sort: '-id',
      }
    },
    async getList() {
      this.listLoading = true
      getTravelersManagement(this.listQuery)
        .then(response => {
          this.list = response.data.travelsList
          this.total = response.data.total
        })
        .catch(err => {
          console.log(err)
        })
        .finally(() => {
          this.listLoading = false
        })
    },
    async saveData() {
      if (!this.agencyCode) {
        alert(`無法取得登入者旅行社代碼，無法設定。`)
        return
      }
      let payload = {
        agencyCode: this.agencyCode,
        userID: this.complaintRemindForm.userID,
        hasComplaint: this.complaintRemindForm.hasComplaint,
        complaintRemind: this.complaintRemindForm.complaintRemind,
      }
      this.listLoading = true
      try {
        let resp = await setTravelersManagement(payload)
        Message({
          message: '資料處理完成',
          type: 'success',
          duration: 5 * 1000,
        })
        this.dialogFormVisible = false
      } catch (error) {
        console.log(error)
      } finally {
        this.listLoading = false
        await this.getList()
      }
    },
    editData(row) {
      const vm = this
      // vm.authEdit = checkPermission(["ITA-DEV", "ITA-ADMIN", "ITA-ADM-STAFF", "ITA-TRAVEL-AGENCY"]);
      // if (!vm.authEdit) return alert("權限不足")
      vm.dialogFormVisible = true
      vm.selectedTraveler = row
      vm.complaintRemindForm.userID = row.userID
      vm.complaintRemindForm.hasComplaint = row.hasComplaint
      vm.complaintRemindForm.complaintRemind = row.complaintRemind
    },
  },
}
</script>
<style lang="scss">
.traveler-data {
  .el-dialog__body {
    padding: 15px;
  }

  .el-table .alert-row {
    background: #ffaec8;
  }

  .el-table--enable-row-hover .el-table__body tr.alert-row:hover > td {
    background: #fa95b5;
  }
}

.traveler-complaint-remind .el-dialog__body {
  padding-top: 6px !important;
  padding-bottom: 0 !important;
}
</style>

<style scoped>
/deep/.leader-data .el-form .is-disabled * {
  color: blue !important;
}

/deep/.el-upload .el-button {
  display: none !important;
}

/deep/.el-upload-list__item-status-label {
  display: none !important;
}

/deep/.el-icon-close {
  display: none !important;
}

.full-height {
  position: relative;
  height: 100%;
}
</style>
